;(function (angular, _) {
  'use strict'

  class GeneratedNumberInputController {
  }

  angular.module('kilo.common.components')
    .component('generatedNumberInput', {
      bindings: {
        number: '<',
        isDraft: '<'
      },
      controller: GeneratedNumberInputController,
      templateUrl: '/app/common/components/generated-number-input/generated-number-input.template.html'
    })
})(window.angular, window._)
